import React, { useEffect, useState } from 'react'
import { useTranslation } from '@sailor/i18n-web'
import { useRequest } from 'ahooks'
import { Drawer } from '@roo/roo'
import CommonTable from '@/components/CommonTable'
import { getI18nTime } from '@/common/utils/i18nFuncs'
import { fetchBatchAdjustRecords } from '@/pages/balance/utils/api'
import { IBatchRecordItem } from '@/pages/balance/utils/types'

interface BatchRecordDrawerProps {
  visible: boolean
  rulePackageId: string
  onClose: () => void
}

const BatchRecordDrawer: React.FC<BatchRecordDrawerProps> = ({
  visible,
  rulePackageId,
  onClose,
}) => {
  const { t } = useTranslation()
  const [pageInfo, setPageInfo] = useState({ pageNo: 1, pageSize: 20 })

  const { data: listRes, loading, run } = useRequest(
    () => fetchBatchAdjustRecords({ ...pageInfo, rulePackageId }),
    { manual: true }
  )

  useEffect(() => {
    if (visible) {
      run()
    }
  }, [pageInfo, visible])

  const columns = [
    {
      title: t('e_pc_operation_time', '操作时间'),
      dataIndex: 'time',
      width: 150,
      render: (time: number) => getI18nTime(time),
    },
    {
      title: t('e_pc_operator', '操作人'),
      dataIndex: 'operator',
      width: 120,
    },
    {
      title: t('e_pc_operation_result', '操作结果'),
      dataIndex: 'resultMsg',
      width: 100,
    },
    {
      title: t('e_pc_result_download', '结果文件下载'),
      dataIndex: 'resultFileUrl',
      width: 140,
      render: (link: string, record: IBatchRecordItem) =>
        link ? (
          <a href={link} target="_blank" rel="noopener noreferrer">
            {record.resultFileName || link.split('/').pop()}
          </a>
        ) : '--',
    },
    {
      title: t('e_pc_import_download', '导入文件下载'),
      dataIndex: 'importFileUrl',
      width: 140,
      render: (link: string, record: IBatchRecordItem) =>
        link ? (
          <a href={link} target="_blank" rel="noopener noreferrer">
            {record.importFileName || link.split('/').pop()}
          </a>
        ) : '--',
    },
  ]

  return (
    <Drawer
      title={t('e_pc_bulk_adjust_records', '批量调整记录')}
      width={800}
      visible={visible}
      onClose={onClose}
      placement="right"
    >
      <CommonTable
        rowKey="time"
        loading={loading}
        columns={columns}
        data={listRes?.result || []}
        pagination={{
          total: listRes?.totalCount,
          pageSize: pageInfo.pageSize,
          onChange: (pageNo: number, pageSize: number) => setPageInfo({ pageNo, pageSize }),
        }}
      />
    </Drawer>
  )
}

export default BatchRecordDrawer
